import TemplateView from '../../../../../../TemplateView'
import HolidayInfoLine from './HolidayInfoLine'

export default class HolidayList extends TemplateView {
    constructor({
        addCorporateDay,
        deleteCorporateDay,
        updateListCallback = () => {},
    }) {
        super()

        this.actions = {
            addCorporateDay,
            deleteCorporateDay,
            updateListCallback,
        }

        this.state = {
            holidays: [],
            isListTransformed: false,
            importedHolidays: {},
        }

        this.holidaysMapInputs = {}

        this.onAnyStatePropertyChanged(['holidays', 'isListTransformed'], () => {
            if (this.state.isListTransformed) {
                this.updateList()
            } else {
                this.updateListState()
            }
        })

        this.onStatePropertyChanged('importedHolidays', (importedHolidays) => {
            Object.keys(this.holidaysMapInputs).forEach((holidayDate) => {
                this.holidaysMapInputs[holidayDate].setState({imported: !!importedHolidays[holidayDate]})
            })
        })
    }

    templateHtml() {
        return '<div class="list"/>'
    }

    afterRender() {
        this.updateList()
    }

    updateList() {
        this.getEl().empty()

        this.holidaysMapInputs = {}

        this.state.holidays.forEach(holiday => {
            this.holidaysMapInputs[holiday.date] = new HolidayInfoLine({
                date: Date.parseJSONDate(holiday.date),
                name: holiday.name,
                editCallback: (date, isWorking, title) => this.actions.addCorporateDay(date, isWorking, title),
                deleteCallback: (date) => this.actions.deleteCorporateDay(date),
            }).init(this.getEl())
        })

        this.actions.updateListCallback()
    }

    updateListState() {
        this.state.holidays.forEach(holiday => {
            this.holidaysMapInputs[holiday.date]
            && this.holidaysMapInputs[holiday.date].setState({
                name: holiday.name,
            })
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/holidayList/components/HolidayList.js